import { ConfirmButtonProps } from "@/shared/form/button";
import { CreateCompanyDocumentConfirmationForActivePersons } from "./create-company-document-confirmation-for-active-persons";
import { useTranslations } from "use-intl";
import Form from "@/shared/form/form";
import { FieldsType } from "./mode/types";
import { ConfirmButton } from "@/shared/form/button";
import { PlusOutlined } from "@ant-design/icons";

export function CreateCompanyDocumentConfirmationForActivePersonsAsButton({
  documentId,
  buttonProps,
}: {
  documentId: string;
  buttonProps?: ConfirmButtonProps;
}) {
  const t = useTranslations("Documents");
  const [form] = Form.useForm<FieldsType>();

  return (
    <>
      <div className="hidden">
        <CreateCompanyDocumentConfirmationForActivePersons
          documentId={documentId}
          form={form}
        />
      </div>
      <ConfirmButton
        variant={"text"}
        color={"primary"}
        accent
        icon={<PlusOutlined />}
        onClick={async () => form.submit()}
        {...buttonProps}
      >
        {t("Create confirmation for active")}
      </ConfirmButton>
    </>
  );
}
